/*
This embedded shorthand script will look for shorthand placeholders and load the corresponding content.
This must be activated in the specific theme scripts index if required.
 */
export function embeddedShorthand(): void {
    const shorthandElements = document.querySelectorAll('.bg-shorthand-embed');
    // only setup shorthand if found on the page
    if (shorthandElements.length > 0) {
        // prepare page for shorthand content
        document.body?.classList.remove('bg-sticky-header');
        document.querySelector('.bg-heading-breadcrumb')?.remove();

        // load shorthand embedded script
        const scriptEl = document.createElement('script');
        scriptEl.setAttribute('async', '');
        scriptEl.setAttribute('src', `https://embed.shorthand.com/embed_9.js`);
        scriptEl.addEventListener('load', () => {
            // trigger document content loaded for shorthand to initialise
            document.dispatchEvent(new Event("DOMContentLoaded", { bubbles: true, cancelable: true }));
        })
        document.head.appendChild(scriptEl);

        // hide shorthand logo
        const styleEl = document.createElement('style');
        styleEl.innerHTML = '.Theme-Footer a.Theme-FooterLogo--container { display: none; }';
        document.head.appendChild(styleEl);
    }
}